import React, { useMemo } from 'react'
import { useForm } from '../form'

export const Label = ({ children, name, label, hidden, required }) => {
  const { getFormError } = useForm()

  const labelValue = useMemo(() => label || name, [label, name])

  let error = getFormError(name)

  let requiredError = useMemo(() => error === 'required', [error])

  return (
    <React.Fragment>
      {!hidden &&
        <div className="form-group my-2">
          {labelValue &&
            <label className="text-capitalize mb-2">
              {labelValue}
            </label>}
          {children}
          <div>
            {required && <small className={`${requiredError && 'text-danger'}`}>required</small>}
          </div>
        </div>}
    </React.Fragment>
  )
}
